import { Injectable } from '@angular/core';
// import { WebSocketSubject, webSocket } from 'rxjs/webSocket';
import { HttpClient } from '@angular/common/http';
import { io, Socket } from 'socket.io-client';
import { Observable, Subject } from 'rxjs';
import { environment } from '../../environments/environment';
import { Const } from '../static/const';

@Injectable({
  providedIn: 'root',
})
export class WebSocketService {
  // private socket$: WebSocketSubject<any>;
  private socket: Socket;

  private socketEventSubject = new Subject<{ event: string; data: any }>();
  public socketEvents$ = this.socketEventSubject.asObservable();

  constructor() {
    // this.socket$ = webSocket('wss://echo.websocket.org');
    // this.socket = io(Const.connectionUrl);

    // this.socket.on('connect', () => {
    //   console.log('Connected to WebSocket:', this.socket.id);
    // });

    // this.socket.on('disconnect', () => {
    //   console.log('Disconnected from WebSocket');
    // });

    //qa
    // this.socket = io(
    //   'https://bnlwe-es02-q-931435-unilevercom-webapp-01.azurewebsites.net'
    // );

    //dev

    // before
    // this.socket = io(Const.socketUrl);

    // After
    // Force WebSocket transport only
    this.socket = io(Const.socketUrl, {
      transports: ['websocket'],
    });
    this.socket.on('connect', () => {
      console.log('Connected to WebSocket:', this.socket.id);
    });

    this.socket.on('disconnect', () => {
      console.log('Disconnected from WebSocket');
    });

    // Register all events here
    this.registerSocketEvent('save_veeva');
    this.registerSocketEvent('save_ira_veeva');
    this.registerSocketEvent('save_edit_la');
    this.registerSocketEvent('save_draft');
    this.registerSocketEvent('draft_error');
  }

  private registerSocketEvent(eventName: string) {
    this.socket.on(eventName, (data: any) => {
      this.socketEventSubject.next({ event: eventName, data });
    });
  }

  onResultDataSaved(): Observable<any> {
    return new Observable((observer) => {
      this.socket.on('save_veeva', (data) => {
        observer.next(data);
      });
    });
  }

  onIraDataSaved(): Observable<any> {
    return new Observable((observer) => {
      this.socket.on('save_ira_veeva', (data) => {
        observer.next(data);
      });
    });
  }

  onEditLADataSaved(): Observable<any> {
    return new Observable((observer) => {
      this.socket.on('save_edit_la', (data) => {
        observer.next(data);
      });
    });
  }

  onDraftDataSaved(): Observable<any> {
    return new Observable((observer) => {
      this.socket.on('save_draft', (data) => {
        observer.next(data);
      });
    });
  }

  onDataError(): Observable<any> {
    return new Observable((observer) => {
      this.socket.on('draft_error', (error) => {
        observer.next(error);
      });
    });
  }

  // Send a message to the server
  // sendMessage(message: any) {
  //   this.socket$.next(message);
  // }

  // // Receive messages from the server
  // getMessages(): Observable<any> {
  //   return this.socket$.asObservable();
  // }

  // // Close the WebSocket connection
  // closeConnection() {
  //   this.socket$.complete();
  // }
}
